module.exports = __webpack_public_path__ + "img/hero-header-bg.d0055a19.png";